export default "__VITE_ASSET__qew8VS7p__"